import { apiSlice } from '../apiSlice'

export const dashBoardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSalesSummary: builder.query({
      query: () => `/dashboard/summary`,
      keepUnusedDataFor: 600,
      providesTags: () => [{ type: 'salesSummary' }],
    }),
  }),
})
export const { useGetSalesSummaryQuery } = dashBoardApi
